module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pedido/codigos-promocion/codigos-promocion.component.html
// module id = ./src/app/pedido/codigos-promocion/codigos-promocion.component.html
// module chunks = main